/* eslint jsx-a11y/aria-role: 0 */

import React, {Component} from "react";
import {Field} from 'redux-form';
import uploadcare from "uploadcare-widget";

class Uploader extends Component {

  componentDidMount() {
    const widget = uploadcare.Widget('[role=uploadcare-uploader]');

    widget.onUploadComplete(() => {
      this.props.changeFieldValue('seasonForm', this.props.input.name, document.getElementsByName("photoUrl")[0].value)
      this.props.changeFieldValue('seasonPaddockForm', this.props.input.name, document.getElementsByName("photoUrl")[0].value)
      this.props.changeFieldValue('seasonMediaForm', this.props.input.name, document.getElementsByName("photoUrl")[0].value)
    })
  }

  render() {
    const { validateFields, input, label, meta: { touched, error }} = this.props;
    const key = process.env.REACT_APP_UPLOADCARE_PUBLIC_KEY;
    return (
      <div className="form-group">
        <Field component="input" type="hidden" name={input.name} role="uploadcare-uploader" data-public-key={key} data-images-only validate={validateFields} data-crop="500:500" />
        {(touched && error) && <label id={`${input.name}-error`} className="error" htmlFor={input.name}>{error}</label>}
      </div>
    )
  }
}

export default Uploader;



// WEBPACK FOOTER //
// ./src/components/RequestForm/UploadcareUploader.js